'use client';

import React, { FC } from 'react';

import PartServiceCart from '@/components/part-service-cart/part-service-cart';
import { IService } from '@/contentful/utils/services';

import styles from './part-other-services.module.scss';

interface IPartOtherServices {
  data: {
    lang: string | undefined;
    title: string | undefined;
    services: IService[];
  };
}

const PartOtherServices: FC<IPartOtherServices> = ({
  data: { lang, title, services },
}) => (
  <section className={styles.container}>
    <h2 className={styles.title}>{title}</h2>
    <div className={styles.servicesList}>
      {services.map((service) => (
        <PartServiceCart
          service={service}
          lang={lang ?? ''}
          key={service.title}
        />
      ))}
    </div>
  </section>
);

export default PartOtherServices;
